import { render, staticRenderFns } from "./RemedialActions.vue?vue&type=template&id=fdf81cf0&"
import script from "./RemedialActions.vue?vue&type=script&lang=js&"
export * from "./RemedialActions.vue?vue&type=script&lang=js&"
import style0 from "./RemedialActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports